import { defineMessage } from 'react-intl';

import DefaultIntlFormatValues from '../definitions/DefaultIntlFormatValues';
import getGiftOfferTypeAsMessage from './getGiftOfferTypeAsMessage';


/**
 * Return a string that gives a brief description of the gift offer for this product.
 * @param {object} args
 * @param {GiftOfferShape} args.giftCardOffer - gift card offer details
 * @param {number} giftCardOffer.maxDollarValue - maximum dollar value of the gift card
 * @param {string} giftCardOffer.offerType - enum string of offerType
 * @param {import('react-intl').IntlShape} args.intl - internationalization object
 * @param args.isMobile - boolean indicating if the context is mobile
 * @returns {string} - string that describes the gift card offer
 */
function getGiftOfferSummary({ giftCardOffer, intl, isMobile = false }) {
    return intl.formatMessage(
        defineMessage({
            id: 'edb.cc.gift-card-offer',
            defaultMessage: `{isMobile, select, true {} other {Get a }}
                <strong>{maxDollarValue, number, CAD0} {offerType}</strong>
                {isMobile, select, true {} other { upon approval}}`,
        }),
        {
            ...DefaultIntlFormatValues,
            maxDollarValue: giftCardOffer.maxDollarValue,
            offerType: getGiftOfferTypeAsMessage(giftCardOffer.offerType, intl),
            isMobile,
        }
    );
}


export default getGiftOfferSummary;
